export default class {
  public static prefix = 'kellis-ng';
  public static post(inName: string, inData: any) {
    window.top.postMessage({ type: inName, data: inData, system: this.prefix }, '*');
  }
}
